import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { MatxLayoutSettings } from "app/components/MatxLayout/settings";

// Hooks
import useEventDashboard from "./hooks/useEventDashboard";

// Components
import DashboardHeader from "./components/DashboardHeader";
import StatCards from "./components/StatCards";
import PaymentSummary from "./components/PaymentSummary";
import SalesSummary from "./components/SalesSummary";
import ProductBreakdown from "./components/ProductBreakdown";

const EventDashboard = () => {
  const {
    loading,
    eventData,
    summaryData,
    tabValue,
    products,
    handleReviewPayments,
    handleNavigateBack,
  } = useEventDashboard();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress sx={{ color: MatxLayoutSettings.palette.active }} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        backgroundColor: MatxLayoutSettings.palette.lightGrey,
        minHeight: "100vh",
        pb: { xs: 3, sm: 5 },
        pt: { xs: 2, sm: 4 },
      }}
    >
      <Box sx={{ px: { xs: 2, sm: 4 }, mt: { xs: 1, sm: 3 } }}>
        {tabValue === 0 && (
          <Box sx={{ pb: 4 }}>
            {/* HEADER */}
            <DashboardHeader eventData={eventData} onBack={handleNavigateBack} />

            {/* STAT CARDS */}
            <StatCards summaryData={summaryData} ticketProducts={products.tickets} />

            {/* PAYMENT SUMMARY */}
            <PaymentSummary summaryData={summaryData} onReviewPayments={handleReviewPayments} />

            {/* SALES SUMMARY */}
            <SalesSummary summaryData={summaryData} />

            {/* HOTELS */}
            <ProductBreakdown
              title="Hotels"
              description="Booked accommodations across partner hotels"
              products={products.hotels}
              unitLabel="rooms sold"
            />

            {/* ADD-ONS */}
            <ProductBreakdown
              title="Add-ons"
              products={products.addons}
              unitLabel="sold"
            />
          </Box>
        )}

        {tabValue !== 0 && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
              minHeight: { xs: "300px", sm: "400px" },
              backgroundColor: "#fff",
              borderRadius: "12px",
              border: `1px solid ${MatxLayoutSettings.palette.borderGrey}`,
              mb: 4,
              p: 3,
            }}
          >
            <Box textAlign="center">
              <Typography
                variant="h5"
                fontWeight="700"
                color={MatxLayoutSettings.palette.textBlack}
                gutterBottom
                sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
              >
                Coming Soon
              </Typography>
              <Typography color={MatxLayoutSettings.palette.textBlack} sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                We're working hard to bring you the {["Registrants", "Payments", "Reports", "Admin"][tabValue - 1]} view.
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default EventDashboard;
